import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { KTSVG } from '../../../helpers'
import { useQuery } from '@apollo/client'
import { GET_ALL_BG_ACCOUNTS } from '../../../graphql/query'

interface Props {
  franchiseId: any
}

const ViewAllClients: React.FC<Props> = ({ franchiseId }) => {
  const params = useParams()
  const uuid = params.uuid
  const [currentPage, setCurrentPage] = useState<number>(1)
  const ViewClientsPerPage = 10
  const { data, loading, error } = useQuery(GET_ALL_BG_ACCOUNTS, {
    variables: {
      input: {
        franchiseId: franchiseId,
        limit: ViewClientsPerPage,
        offset: (currentPage - 1) * ViewClientsPerPage
      },
      context: {
        headers: {
          'access-control-allow-methods': 'Franchise Clients'
        }
      }
    },
    context: {
      headers: {
        'access-control-allow-methods': 'Franchise Clients'
      }
    }
  })

  const convertCompanySize = (companySize: any) => {
    const ranges: any = {
      belowTwenty: 'Below 20',
      twentyOneToFifty: '21 to 50',
      fiftyOneToTwoHundred: '51 to 100',
      twoHundredOneToFiveHundred: '201 to 500',
      fiveHundredOneToThousand: '501 to 1000',
      thousandPlus: '1000+'
    }

    return ranges[companySize] || companySize
  }
  // Pagination
  const totalClients = data?.getAllBgAccounts?.count
  const totalPages = Math.ceil(totalClients / ViewClientsPerPage)

  // const indexOfLastLead = currentPage * leadsPerPage
  // const indexOfFirstLead = indexOfLastLead - leadsPerPage
  // const currentLeads = allLead.slice(indexOfFirstLead, indexOfLastLead)

  const paginate = (pageNumber: number) => {
    setCurrentPage(pageNumber)
  }

  const nextPage = () => {
    if (
      totalPages > 0 &&
      currentPage < totalPages &&
      data?.getAllFranchise?.franchises.length > 0
    ) {
      setCurrentPage((prevPage) => prevPage + 1)
    }
  }

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1)
    }
  }

  // Generate snake handle pagination numbers
  const generatePaginationNumbers = () => {
    const numbers = []
    const maxVisibleNumbers = 5 // Maximum visible pagination numbers

    if (totalPages <= maxVisibleNumbers) {
      // If total pages are less than or equal to max visible numbers, show all
      for (let i = 1; i <= totalPages; i++) {
        numbers.push(i)
      }
    } else {
      const middleIndex = Math.ceil(maxVisibleNumbers / 2) // Middle index of the pagination numbers
      let startPage = currentPage - middleIndex + 1
      let endPage = currentPage + middleIndex - 1

      if (startPage < 1) {
        // If start page is less than 1, adjust start and end page accordingly
        endPage = startPage + maxVisibleNumbers - 1
        startPage = 1
      } else if (endPage > totalPages) {
        // If end page is greater than total pages, adjust start and end page accordingly
        startPage = endPage - maxVisibleNumbers + 1
        endPage = totalPages
      }

      for (let i = startPage; i <= endPage; i++) {
        numbers.push(i)
      }
    }

    return numbers
  }

  if (data) {
    console.log(data)
  }

  if (error) {
    console.log(error)
  }
  if (loading) {
    return <>Loading....</>
  }

  return (
    <div className={`card mb-5 mb-xl-8`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-3 mb-1'>Clients Details</span>
        </h3>
        <div className='card-toolbar' title='Click to add a user'>
          <Link to={`/franchise/clients/new-onboarding/${franchiseId}`}>
            <div className='btn btn-sm btn-light-primary d-flex'>
              <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
              Onboarding New Customers
            </div>
          </Link>
        </div>
      </div>
      {/* end::Header */}

      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bolder text-muted'>
                <th className='min-w-100px'>Organization</th>
                <th className='min-w-100px'>Address</th>
                <th className='min-w-100px'>Company Size</th>
                <th className='min-w-100px'>Business Contact Number</th>
                <th className='min-w-100px'>Industry</th>
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
              {data && data?.getAllBgAccounts?.bgAccounts !== null ? (
                <>
                  {data?.getAllBgAccounts?.bgAccounts?.map((customer: any, index: number) => (
                    <tr key={index}>
                      <td>
                        <div className='d-flex align-items-center'>
                          {!!customer.organization ? (
                            <div className='text-dark fw-bold text-hover-primary d-block fs-6'>
                              {customer.organization}
                            </div>
                          ) : (
                            <i className='fw-light'>No Data found</i>
                          )}
                        </div>
                      </td>
                      <td>
                        <div className='d-flex justify-content-start flex-column'>
                          {!!customer.registeredAddress ? (
                            <div className='text-dark fw-bold text-hover-primary d-block fs-6'>
                              {customer.registeredAddress}
                            </div>
                          ) : (
                            <i className='fw-light'>No Data found</i>
                          )}
                        </div>
                      </td>
                      <td>
                        <div className='d-flex justify-content-start flex-column'>
                          {!!customer.companySize ? (
                            <div className='text-dark fw-bold text-hover-primary d-block fs-6'>
                              {convertCompanySize(customer.companySize)}
                            </div>
                          ) : (
                            <i className='fw-light'>No Data found</i>
                          )}
                        </div>
                      </td>
                      <td>
                        <div className='d-flex justify-content-start flex-column'>
                          {!!customer.businessContactNumber ? (
                            <div className='text-dark fw-bold text-hover-primary d-block fs-6'>
                              {customer.businessContactNumber}
                            </div>
                          ) : (
                            <i className='fw-light'>No Data found</i>
                          )}
                        </div>
                      </td>
                      <td>
                        <div className='d-flex justify-content-start flex-column'>
                          {!!customer.industry ? (
                            <div className='text-dark fw-bold text-hover-primary d-block fs-6'>
                              {customer.industry}
                            </div>
                          ) : (
                            <i className='fw-light'>No Data found</i>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </>
              ) : (
                <>
                  <p className='text-muted fst-italic mt-auto'>No data is present</p>
                </>
              )}
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* Pagination */}
        <div className='row'>
          <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>
          <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
            <div className='dataTables_paginate paging_simple_numbers' id='kt_table_users_paginate'>
              <ul className='pagination'>
                <li className={`paginate_button page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button
                    type='button'
                    aria-controls='kt_table_users'
                    data-dt-idx='0'
                    className='btn primary page-link'
                    onClick={prevPage}
                  >
                    <i className='previous'></i>
                  </button>
                </li>
                {generatePaginationNumbers().map((pageNumber) => (
                  <li
                    key={pageNumber}
                    className={`paginate_button page-item ${
                      currentPage === pageNumber ? 'active' : ''
                    }`}
                  >
                    <button
                      type='button'
                      aria-controls='kt_table_users'
                      data-dt-idx={pageNumber}
                      className='btn primary page-link'
                      onClick={() => paginate(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                ))}
                <li
                  className={`paginate_button page-item ${
                    currentPage === totalPages ? 'disabled' : ''
                  }`}
                >
                  <button
                    type='button'
                    aria-controls='kt_table_users'
                    data-dt-idx='0'
                    className='btn primary page-link'
                    onClick={nextPage}
                  >
                    <i className='next'></i>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* end:Body */}
    </div>
  )
}

export default ViewAllClients
